import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=bbaa93dc&lang=pug&"
import script from "./AdminHome.vue?vue&type=script&lang=js&"
export * from "./AdminHome.vue?vue&type=script&lang=js&"
import style0 from "./AdminHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports